export default __webpack_public_path__ + "static/media/logo2.218ab05b.png";